<template>
  <v-container class="container">
    <v-form ref="formDevice" v-model="valid" lazy-validation>
      <div style="padding-top: 55px;"></div>
      <v-data-table v-if="notifications.length>0"
                    :items="notifications"
                    class="elevation-1"
                    sort-icon="mdi-menu-down"
                    :custom-sort="customSort"
                    hide-actions
                    hide-headers
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td  class="text-xs-left" style="font-weight: bold;">{{ props.item.client.toUpperCase() }} / {{ props.item.device.toUpperCase() }}</td>
            <td  class="text-xs-left">{{ formatDateMinus(props.item.date) }}</td>
          </tr>
          <tr>
            <td  class="text-xs-left">{{ translateData(props.item.type) }}</td>
            <td  class="text-xs-left">{{ translateData(props.item.status) }}</td>
            <td class="text-xs-left">
            </td>
          </tr>
          <tr>
            <td><a target="_blank" v-if="props.item.positionId!='0'" @click="getLocation(props.item)">Ubicación</a></td>
          </tr>
          <tr style="border-bottom: 1px solid black"></tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          No se han encontrado resultados para "{{ search }}".
        </v-alert>
      </v-data-table>
    </v-form>
    <v-dialog v-if="dialogInfo==true"
              v-model="dialogInfo"
              width="800px"
              transition="dialog-bottom-transition"
              scrollable>
      <v-card tile>
        <v-toolbar card dark color="nav_background_color">
          <v-btn icon dark @click.native="dialogInfo = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Información de ubicación</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <GmapMap
                ref="gmap"
                :center="this.mapView"
                :zoom="14"
                map-type-id="roadmap"
                :options="{
                      scaleControl: true,
                      mapTypeControl: true,
                      zoomControl: true,
                      scrollwheel: true,
                      gestureHandling: 'greedy'
                    }"
                style="width: 100%; height: 85vh"
            >
              <GmapMarker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  :clickable="true"
                  :icon="m.icon"
              />
            </GmapMap>
          </v-form>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import VueTimepicker from 'vue2-timepicker/src'

export default {
  props: [
    'devices',
    'device',
  ],
  components: {
    VueTimepicker,
  },
  data() {
    return {
      dialogInfo: false,
      search: '',
      valid: false,
      requiredField: [v => !!v || 'Es requerido'],
      dialog: false,
      notifications:[],
      headers: [
        { text: 'Fecha y hora', value: 'date' },
        { text: 'Tipo notificación', value: 'type' },
        { text: 'Ubicación', value: 'catalogueItemId' },
      ],
    };
  },
  watch: {},
  methods: {
    reload(){
      this.notifications=[]
      let queryParam = ''
      if(this.device!=null && this.device.idTraccar!=null){
        queryParam = "deviceId="+this.device.idTraccar+"&from="+this.dateStart()+"&to="+this.dateEnd()
      }else if(this.device.id==null || this.device.id=='') {
        queryParam = "from="+this.dateStart()+"&to="+this.dateEnd()
      }
      this.$store.dispatch('getDevicesLocationTraccarAlarm', queryParam).then(response => {
        if(response.data!=null && this.device!=null && this.device.id!=null){
          this.$store.dispatch('getDevice', this.device.id).then(responseDevice => {
            let object = JSON.parse(responseDevice.data.value)
            object.id = responseDevice.data.id
            object.selected = false
            object.user = responseDevice.data.user
            object.fullData = object.imei+" "+object.name
            response.data.device=object
            for (const notification of response.data) {
              if(notification.type == "deviceOverspeed" && JSON.stringify(notification.attributes) !== JSON.stringify({})){
                let overSpeedAtributes = notification.attributes;
                notification.attributes = "Velocidad: " + (overSpeedAtributes.speed*1.852).toFixed(2) + "km/h, velocidad máxima: " + (overSpeedAtributes.speedLimit*1.852).toFixed(0) + "km/h";
              }
              if(notification.type == "deviceOnline" || notification.type == "deviceUnknown" || notification.type == "deviceOffline"){
                    continue
                  }
              this.notifications.push({id:notification.id, date:notification.eventTime, type:notification.type, device:object.name, client:object.login, location:notification.latitude+","+notification.longitude, status:notification.attributes, positionId:notification.positionId, idTraccar:notification.deviceId})
            }
            this.notifications.sort((a, b)=> b.id - a.id);
          })
        }else if(response.data!=null){
          for (const dev of this.devices) {
            for (const notification of response.data) {
              if(dev.idTraccar===notification.deviceId){
                if(JSON.stringify(notification.attributes) !== JSON.stringify({})){
                  if(notification.type == "deviceOverspeed"){
                    let overSpeedAtributes = notification.attributes;
                    notification.attributes = "Velocidad: " + (overSpeedAtributes.speed*1.852).toFixed(2) + "km/h, velocidad máxima: " + (overSpeedAtributes.speedLimit*1.852).toFixed(0) + "km/h";
                  }
                  if(notification.type == "deviceOnline" || notification.type == "deviceUnknown" || notification.type == "deviceOffline"){
                    continue
                  }
                  this.notifications.push({id:notification.id, date:notification.eventTime, type:notification.type, device:dev.name, client:dev.login, location:notification.latitude+","+notification.longitude, status:notification.attributes, positionId:notification.positionId, idTraccar:notification.deviceId})
                }
              }
            }
          }
        }else{
          this.$store.state.dialogError = true;
          this.$store.state.dialogErrorMessage = "No existen notificaciones para el dispositivo seleccionado";
        }

      })
    },

    customSort(items) {
      return items;
    },

    formatDate(dateString) {
      let date = new Date(dateString);
      var day = date.getDate() + "";
      var month = (date.getMonth() + 1) + "";
      var year = date.getFullYear() + "";
      var hour = (date.getHours() + 5) > 23 ? date.getHours() : date.getHours() + 5 + "";
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";
      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);
      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);
      return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
    },

    dateStart(){
      let date = new Date();
      let hours = 730;
      let miliseconds = 1000 * 60 * 60 * hours; // Hours in miliseconds

      date.setTime(date.getTime() - miliseconds);

      var day = date.getDate() + "";
      var month = date.getMonth() + 1 + "";
      var year = date.getFullYear() + "";
      var hour = date.getHours()+"";
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";


      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + "T" + hour + ":" + minutes + ":" + seconds+"-05";
    },

    dateEnd(){
      let date = new Date();
      let hours = 5;
      let miliseconds = 1000 * 60 * 60 * hours; // Hours in miliseconds

      date.setTime(date.getTime() + miliseconds);

      var day = date.getDate() + "";
      var month = date.getMonth() + 1 + "";
      var year = date.getFullYear() + "";
      var hour = date.getHours() + "";
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";

      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + "T" + hour + ":" + minutes + ":" + seconds+"-05";
    },

    formatDateMinus(dateString) {
      let date = new Date(dateString);
      var day = date.getDate() + "";
      var month = (date.getMonth() + 1) + "";
      var year = date.getFullYear() + "";
      var hour = date.getHours() + "";
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";
      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);
      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
    },
    translateData(data){
      const dataTransform = JSON.stringify(data)
      if(dataTransform==='"commandResult"'){
        return 'Ejecución de comando'
      }else if(dataTransform==='{"result":"Cut off the fuel supply: Success!"}'){
        return 'Se ha cortado la energía!'
      }else if(dataTransform.toString()==='{"result":"Restore fuel supply: Success!"}'){
        return 'Se ha restablecido la energía!'
      }else if(dataTransform.toString()==='"deviceOffline"'){
        return 'Vehículo fuera de línea!'
      }else if(dataTransform.toString()==='"deviceOnline"'){
        return 'Vehículo en línea'
      }else if(dataTransform.toString()==='"ignitionOn"'){
        return 'Vehículo Encendido'
      }else if(dataTransform.toString()==='"ignitionOff"'){
        return 'Vehículo Apagado'
      }else if(dataTransform.toString()==='"alarm"'){
        return 'Alarma del Vehículo'
      }else if(dataTransform.toString()==='{"alarm":"sos"}'){
        return 'SOS Auxilio'
      }else if(dataTransform.toString()==='{"alarm":"powerCut"}'){
        return 'Corte de energía'
      }else if(dataTransform.toString()==='{"alarm":"lowBattery"}'){
        return 'Batería Baja'
      }else if(dataTransform.toString()==='{"alarm":"overspeed"}'){
        return 'Vehículo superó el límite de velocidad'
      }else if(dataTransform.toString().includes('Cut off the fuel supply: Success')){
        return 'Se ha cortado la energía!'
      }else if(dataTransform.toString().includes('"deviceMoving"')){
        return 'Vehículo en movimiento'
      }else if(dataTransform.toString().includes('"deviceStopped"')){
        return 'Vehículo detenido'
      }else if(dataTransform.toString().includes('"deviceUnknown"')){
        return 'Vehículo desconocido'
      }else if(dataTransform.toString().includes('"geofenceEnter"')){
        return 'Entra a Geocerca'
      }else if(dataTransform.toString().includes('"geofenceExit"')){
        return 'Sale de Geocerca'
      }else if(dataTransform.toString().includes('Already in the state')){
        return 'El Vehículo ya se encuentra en el estado solicitado. El comando no fue ejecutado'
      }else if(dataTransform.toString().includes('"deviceOverspeed"')){
        return 'Vehículo superó el límite de velocidad'
      }else if(dataTransform.toString()==='{}'){
        return ''
      }else {
        return data
      }

    },

    getLocation(item){
      this.editedIndex = this.notifications.indexOf(item);

      let queryParam = "id="+[this.notifications[this.editedIndex].positionId]
      this.$store.dispatch('getDevicesLocationTraccarReport',queryParam).then(
          response => {
            for (const dev of this.devices) {
              if(dev.idTraccar!=null && dev.idTraccar===this.notifications[this.editedIndex].idTraccar){
                let image = dev.image
                if(response.data.result[0].accStatus=='1' && parseInt(response.data.result[0].speed)>0){
                  image = image.replace("1.", "V.");
                }else if(response.data.result[0].accStatus=='0'){
                  image = image.replace("1.", "R.");
                }else if(response.data.result[0].accStatus=='1' && response.data.result[0].speed=='0'){
                  image = image.replace("1.", "A.");
                }else{
                  image = image.replace("1.", "V.");
                }
                this.markers=[]
                this.imageDevice = image
                let respPosition = {
                  position: {
                    lat: response.data.result[0].lat,
                    lng: response.data.result[0].lng,
                  },
                  icon: {
                    url2: dev.image,
                    url: image,
                    scaledSize: {width: 40, height: 40, f: 'px', b: 'px'},
                    rotation: [45]
                  }
                }
                this.mapView = {
                  lat: response.data.result[0].lat,
                  lng: response.data.result[0].lng
                }
                this.markers.push(respPosition)
                this.dialogInfo = true
              }
            }

          },
          error => {
            this.$store.state.dialogError = true;
          }
      );
    },
    checkZero(data) {
      if (data.length == 1) {
        data = "0" + data;
      }
      return data;
    },

  },
  computed: {},
  created() {
    this.reload()
  },

};
</script>

<style scoped>
.container {
  max-width: 100% !important;
  padding: 0%;
}

</style>



// WEBPACK FOOTER //
// src/components/device/mobile/AlertMobile.vue